import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="project-img" />

      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {/* Tech stack (NEW 🔥) */}
        {props.techStack && (
          <p className="purple" style={{ fontSize: "0.9em" }}>
            <b>Tech:</b> {props.techStack}
          </p>
        )}

        {/* GitHub Button */}
        <Button
          variant="primary"
          href={props.ghLink}
          target="_blank"
        >
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>

        {/* Demo Button */}
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            Live Demo
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;